import React from "react";
import { FaCheck } from "react-icons/fa";
import { FiMoreHorizontal } from "react-icons/fi";
import { orderStatus } from "../../constants/commonConstants";
import { formatOrderStatus } from "../../utils/formatting";

const getTrackOrderStatusLabel = (status, isWriterAssigned) => {
  if (status === orderStatus.PENDING_WRITER || (status === orderStatus.ORDER_IN_PROGRESS && !isWriterAssigned)) {
    return "Assigning expert";
  }

  return formatOrderStatus(status);
};

const TrackOrder = ({ trackOrder = [], currentState = null, isWriterAssigned = true, onRequestRevision, onMarkComplete }) => {
  const isAwaitingWriterAssignment = !isWriterAssigned && (
    currentState === orderStatus.PENDING_WRITER ||
    currentState === orderStatus.ORDER_IN_PROGRESS
  );

  const getActiveStep = () => {
    if (isAwaitingWriterAssignment) {
      return orderStatus.PENDING_WRITER;
    }

    if (
      currentState === orderStatus.ORDER_IN_PROGRESS
    ) {
      return orderStatus.ORDER_IN_PROGRESS;
    }

    if (currentState === orderStatus.PENDING_PAYMENT) {
      return orderStatus.PENDING_PAYMENT;
    }

    if (currentState === orderStatus.ORDER_DELIVERED) {
      return orderStatus.ORDER_DELIVERED;
    }

    if (currentState === orderStatus.IN_REVISION) {
      return orderStatus.IN_REVISION;
    }

    if (currentState === orderStatus.COMPLAINT_RAISED) {
      return orderStatus.COMPLAINT_RAISED;
    }

    return null;
  };

  const activeStep = getActiveStep();

  // getting copy of status array before to changing ==========================================================================================
  const copyOfTrackOrder = [...trackOrder];

  // excluding some status those should hidden in the client side application =================================================================
  trackOrder = trackOrder?.filter(status => {
    if(
      (status === orderStatus.PENDING_PAYMENT && copyOfTrackOrder?.includes(orderStatus.PENDING_WRITER)) ||
      (status === orderStatus.ORDER_DELIVERED && currentState === orderStatus.ORDER_DELIVERED && copyOfTrackOrder?.includes(orderStatus.IN_REVISION))
    ) {
      return false;
    }
    return status;
  });

  // refactoring structure of the status array element ========================================================================================
  trackOrder = trackOrder?.map(it => {
    if(isAwaitingWriterAssignment && (it === orderStatus.PENDING_WRITER || it === orderStatus.ORDER_IN_PROGRESS)) {
      return {step: orderStatus.PENDING_WRITER, completed: true}
    }
    if(it === orderStatus.PENDING_WRITER && !(copyOfTrackOrder.includes(orderStatus.ORDER_IN_PROGRESS))){
      it = orderStatus.ORDER_IN_PROGRESS;
    }
    if(it === orderStatus.PENDING_WRITER && copyOfTrackOrder.includes(orderStatus.ORDER_IN_PROGRESS)){
      it = null;
    }
    return {step: it, completed: true}
  });

  // extracting only the unique values ========================================================================================================
  trackOrder = trackOrder?.filter((step, index, steps) => (
    step?.step && steps.findIndex(item => item?.step === step.step) === index
  ));

  if(trackOrder?.includes(orderStatus.IN_REVISION) && currentState === orderStatus.ORDER_DELIVERED && !(trackOrder?.includes(orderStatus.ORDER_DELIVERED))){
    trackOrder.push({step: orderStatus.ORDER_DELIVERED, completed: true});
  }

  // appending the next state that should be happen in future =================================================================================
  if(trackOrder[trackOrder.length - 1]?.step === orderStatus.ORDER_IN_PROGRESS){
    trackOrder.push({step: orderStatus.ORDER_DELIVERED, completed: true})
  }else if(trackOrder[trackOrder.length - 1]?.step === orderStatus.ORDER_DELIVERED){
    trackOrder.push({step: orderStatus.COMPLETED, completed: true})
  }else if(trackOrder[trackOrder.length - 1]?.step === orderStatus.IN_REVISION && currentState === orderStatus.ORDER_DELIVERED){
    trackOrder.push({step: orderStatus.ORDER_DELIVERED, completed: true})
  }else if(trackOrder[trackOrder.length - 1]?.step === orderStatus.COMPLAINT_RAISED){
    trackOrder.push({step: orderStatus.RESOLVED, completed: true})
  }

  if(trackOrder[trackOrder.length - 1]?.step === orderStatus.ORDER_DELIVERED && copyOfTrackOrder.includes(orderStatus.IN_REVISION)){
    trackOrder.push({step: orderStatus.COMPLETED, completed: true})
  }
  
  // set the last element of the array to a incompleted state =================================================================================
  if(
    (currentState !== orderStatus.COMPLETED && currentState !== orderStatus.RESOLVED) &&
    (
      currentState === orderStatus.PENDING_PAYMENT || 
      currentState === orderStatus.PENDING_WRITER || 
      currentState === orderStatus.ORDER_IN_PROGRESS ||
      currentState === orderStatus.ORDER_DELIVERED || 
      currentState === orderStatus.COMPLAINT_RAISED || 
      currentState === orderStatus.IN_REVISION
    )
  ){
    trackOrder[trackOrder.length - 1].completed = false;
  }
  
  // if(currentState === orderStatus.ORDER_DELIVERED && trackOrder[trackOrder.length - 1]?.step === orderStatus.ORDER_DELIVERED){
  //   trackOrder[trackOrder.length - 1].completed = true;
  // }

  if(currentState){
    return (
      <div className="mt-[22px]">
        {/* Header */}
        <div className="flex items-start justify-between">
          <h1 className="ml-3 sm:ml-[20px] font-roboto font-semibold text-[18px] leading-5 text-primary mb-4">
            Track Order
          </h1>
          <div className="mr-3 sm:mr-[20px]">
            <FiMoreHorizontal className="w-[20px]" />
          </div>
        </div>
  
        {/* Track Order Steps */}
        <div className="flex flex-col font-inter items-start ml-3 sm:ml-[22px]">
          {trackOrder?.map((step, index) => (
            step?.step && 
              (
                <div key={index} className="flex items-start">
                  {/* Icon */}
                  <div className="flex flex-col items-center">
                    <div
                      className={`relative w-4 h-4 rounded-full ${
                        step.completed
                          ? "bg-blue-shades"
                          : "bg-white border border-blue-shades"
                      } flex items-center justify-center`}
                    >
                      {step.completed ? (
                        <span className="text-white text-xs">
                          <FaCheck className="w-2 h-2" />
                        </span>
                      ) : (
                        <>
                          {step.step === activeStep && (
                            <span className="absolute inset-[-4px] rounded-full border border-blue-shades opacity-60 animate-ping" />
                          )}
                          <span className="h-2 w-2 rounded-full border-2 border-blue-shades border-t-transparent animate-spin" />
                        </>
                      )}
                    </div>
                    {/* Vertical Line */}
                    {index !== trackOrder.length - 1 && (
                      <div
                        className={`h-4 w-[2px] ${
                          step.completed ? "bg-blue-shades" : "bg-gray"
                        }`}
                      ></div>
                    )}
                  </div>
      
                  {/* Step Description */}
                  <div className="ml-4 flex min-h-[16px] items-center gap-1.5">
                    <p
                      className={`text-level-5 font-medium leading-3 ${
                        step.completed ? "text-gray" : "text-secondary"
                      }`}
                    >
                      {getTrackOrderStatusLabel(step.step, isWriterAssigned)}
                    </p>
                    {step.step === activeStep && (
                      <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2 py-0.5 font-inter text-[10px] font-semibold leading-3 text-blue-shades" aria-label="Current step in progress">
                        <span className="h-2 w-2 rounded-full border-2 border-blue-shades border-t-transparent animate-spin" />
                        {isAwaitingWriterAssignment ? "Assigning" : "In progress"}
                      </span>
                    )}
                  </div>
                </div>
              )
          ))}
        </div>
  
        {/* Action Buttons */}
      </div>
    );
  }
};

export default TrackOrder;
